/**
 * Skeleton della colonna chat: 3-4 "bolle" grigie animate di larghezza variabile,
 * alcune allineate a sinistra (messaggi assistant) e una a destra (utente).
 * Non mostra alcun testo: il movimento delle barre dà feedback di attesa.
 */
export default function ChatSkeleton({ testid = 'chat-skeleton' }) {
  return (
    <div
      className="flex flex-col min-h-0 border border-line bg-paper"
      data-testid={testid}
    >
      {/* finto header */}
      <div className="flex items-baseline justify-between px-6 py-4 border-b border-line">
        <div className="h-4 w-40 bg-line animate-pulse rounded" />
        <div className="h-3 w-20 bg-line animate-pulse rounded" />
      </div>

      {/* finto input */}
      <div className="border-b border-line p-4">
        <div className="h-[88px] w-full bg-line animate-pulse rounded-none" />
      </div>

      {/* finti messaggi */}
      <div className="flex-1 overflow-y-auto px-6 py-6 space-y-6">
        {/* primo assistant — riassunto AI, blocco più alto */}
        <div className="space-y-2">
          <div className="h-3 w-28 bg-line animate-pulse rounded" />
          <div className="h-3 w-11/12 bg-line animate-pulse rounded" />
          <div className="h-3 w-10/12 bg-line animate-pulse rounded" />
          <div className="h-3 w-8/12 bg-line animate-pulse rounded" />
          <div className="h-3 w-9/12 bg-line animate-pulse rounded" />
          <div className="h-3 w-6/12 bg-line animate-pulse rounded" />
        </div>

        {/* bolla utente a destra */}
        <div className="flex justify-end">
          <div className="h-9 w-1/3 bg-line animate-pulse rounded" />
        </div>

        {/* secondo assistant */}
        <div className="space-y-2">
          <div className="h-3 w-28 bg-line animate-pulse rounded" />
          <div className="h-3 w-10/12 bg-line animate-pulse rounded" />
          <div className="h-3 w-7/12 bg-line animate-pulse rounded" />
        </div>
      </div>
    </div>
  );
}
